import { render, staticRenderFns } from "./CustomBlockConfig.vue?vue&type=template&id=84c9d7b8&scoped=true"
import script from "./CustomBlockConfig.vue?vue&type=script&lang=js"
export * from "./CustomBlockConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomBlockConfig.vue?vue&type=style&index=0&id=84c9d7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9d7b8",
  null
  
)

export default component.exports